<section class="content">
    <div class="card" style="padding: 25px">
        <div class="row">
            <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
              {{title}} <br>
              <span style="font-size: 15px;"> report gives you the orders that are present in Aavin-Kultivate Software but, no corresponding entry in Axis Banks MIS reports uploaded so far. (Meaning milk went out with out money received.) But, be cautious, sometime the transaction might appear in later date's MIS report</span>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <mat-label>From Date</mat-label>
                <input type="date" [(ngModel)]="from_date"  (ngModelChange)="changeEvent()" class="main-border-class" />
            </div>
            <div class="col-3">
                <mat-label>To Date</mat-label>
                <input type="date" [(ngModel)]="to_date"  (ngModelChange)="changeEvent()"  [min]="from_date" class="main-border-class" />
            </div>
            <div class="col-2">
              <mat-label>Customer Type</mat-label>
              <mat-select [(ngModel)]="selected_customer_type" class="main-border-class" (ngModelChange)="changeEvent()">
                <mat-option [value]="selected_customer_type" *ngFor="let selected_customer_type of customer_type_list">{{selected_customer_type}}</mat-option>
              </mat-select>
            </div>
            <div class="col-2">
                <button (click)="getClicked()"
                  style="font-size: 27px;margin-top: 10%;border-radius: 5px;background: blanchedalmond;"
                  [disabled]="from_date == null || to_date == null">Get</button>
            </div>
            <div *ngIf="!is_document_available" class="col-2">
                <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
                </mat-progress-spinner>
              </div>
            <div class="col-2" *ngIf="document_file!== null">
                <button mat-button class="button-class" (click)="downloadClicked()" style="margin-top:25px"><i class="material-icons">
                    get_app
                  </i> Download Excel</button>
              </div>
        </div>
    </div>

    <div class="card" *ngIf="document_file!== null">
        <div class="container-fluid" style="margin-top: 1%;">
            <table  class="table table-bordered">
              <thead style="text-align: center;">
                <th>Sl.No</th>
                <th>RID</th>
                <th>Amount</th>
                <th>Order For</th>
                <th>Booth/Customer Code</th>
                <th>Status</th>
                <th>Transaction Time</th>
                <th>Transaction Id</th>
                <th>Request Time</th>
                <th>Responce Time</th>
              </thead>
              <tbody>
                <tr *ngFor="let excel of excel_report_data_list; let data_index=index">
                  <td>{{data_index+1}}</td>
                  <td>{{excel['RID']}}</td>
                  <td style="text-align: right;">{{excel['Amount']}}</td>
                  <td>{{excel['Order For']}}</td>
                  <td>{{excel['Booth/Customer Code']}}</td>
                  <th>{{excel.Status}}</th>
                  <td>{{excel['Transaction Time'] | date : 'd/M/y, h:mm a'}}</td>
                  <td>{{excel['Transaction Id']}}</td>
                  <td>{{excel['Request Time'] | date : 'd/M/y, h:mm a'}}</td>
                  <td>{{excel['Responce Time'] | date : 'd/M/y, h:mm a'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
    </div>
</section>